const markerImage = markerColor => `data:image/svg+xml,%3Csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3CradialGradient id='gradient'%3E%3Cstop offset='60%25' stop-color='%23333'/%3E%3Cstop offset='90%25' stop-color='transparent'/%3E%3C/radialGradient%3E%3C/defs%3E%3Ccircle cx='50' cy='50' r='50' fill='url(%23gradient)' /%3E%3Ccircle cx='50' cy='50' r='36' fill='${markerColor}' stroke='white' stroke-width='10' /%3E%3C/svg%3E`;

export default markerImage;



// WEBPACK FOOTER //
// ./public/js/components/Map/MarkerImage.js